// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","ReviewMenu__item":"vz_a"};